import { Box, Flex, Link, Text } from "@chakra-ui/react";
import { ERROR_FINDING_RESULTS, NO_RESULTS } from "../../utils/constants";
import { primaryColor } from "../../utils/colors";
import SpinnerComponent from "../../components/atom/Spinner/SpinnerComponent";

export const renderEmptyState = (error?: string) => (
  <Box width="100%" display="flex" justifyContent="center">
    <Text mx={19.5} my={2.5} fontSize="sm">
      {error ? error : NO_RESULTS}
    </Text>
  </Box>
);

export const renderErrorState = (handleRefresh: () => void) => (
  <Flex gap={2} mx={14} my={2} alignItems="center" justifyContent="center">
    <Text mx={19.5} my={2.5} fontSize="sm">
      {ERROR_FINDING_RESULTS}
      <Link
        color={primaryColor}
        fontWeight="bold"
        onClick={(e) => {
          e.preventDefault();
          handleRefresh();
        }}
      >
        Tentar novamente
      </Link>
    </Text>
  </Flex>
);

export const renderLoadingState = () => (
  <Flex gap={2} mx={14} my={2} alignItems="center" justifyContent="center">
    <SpinnerComponent size="xl" />
    <Text fontSize="sm">Carregar dados...</Text>
  </Flex>
);
